import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

export class SpinnerParam {
  constructor(public state?: boolean, public spinnerName?: string) {}
}

/**
 * A service to show or hide a loading-spinner
 */
@Injectable()
export class CmxSpinnerService {
  spinnerSubj: BehaviorSubject<SpinnerParam> = new BehaviorSubject<SpinnerParam>(new SpinnerParam(false, 'layout'));

  constructor() {}

  show(spinnerType = 'layout') {
    this.spinnerSubj.next(new SpinnerParam(true, spinnerType));
  }

  hide(spinnerType = 'layout') {
    this.spinnerSubj.next(new SpinnerParam(false, spinnerType));
  }

  getSpinner(): Observable<SpinnerParam> {
    return this.spinnerSubj.asObservable();
  }
}
